import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";

export const FooterContainer = styled.div`
  height: 52px;
  display: flex;
  border-top: 2px solid #f4f1eb;
`;

export const CancelButton = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.dark1};
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OKButton = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.blackGradient};
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.golden};
  border-radius: 0 0 8px 0;
`;

export const Modal = styled(AntModal)`
  .ant-modal-content {
    margin: 0;
    padding: 10px 0 0 0;
  }
`;

export const ModalTitle = styled.p`
  color: ${(props) => props.theme.primarySolid};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const ModalText = styled.p`
  color: #858585;
  font-weight: 400;
  font-size: 14px;
  display: block;
  margin-bottom: 20px;
  padding: 0 30px;
  white-space: pre-line;
`;

const BonusConfirmModal = ({
  open,
  onBonusAccept,
  handleClose,
  bonus_percent,
  amount,
  exceed_bonus_limit,
  total_amount,
  max_topup_reward,
}) => {
  const { t } = useTranslation();

  const calculateBonus = () => {
    return exceed_bonus_limit ? max_topup_reward : Math.ceil(amount * bonus_percent * 0.01);
  }

  const calculateTotal = () => {
    return exceed_bonus_limit ? total_amount : (amount + calculateBonus());
  }

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      open={open}
      width={350}
      footer={
        <FooterContainer>
          <CancelButton onClick={handleClose}>
            {t("wallet.reject")}
          </CancelButton>
          <OKButton onClick={onBonusAccept}>{t("wallet.accept")}</OKButton>
        </FooterContainer>
      }
    >
      <div style={{ textAlign: "center" }}>
        <ModalTitle>{t("wallet.topUpBonusTitle")}</ModalTitle>
        <ModalText>
          {t("wallet.bonusConfirmMessage", {
            bonus_percent,
            amount: getFormattedNumber(amount),
            bonus_amount: getFormattedNumber(calculateBonus()),
            total: getFormattedNumber(calculateTotal()),
          })}
          <div>
            {exceed_bonus_limit && `(${t("wallet.maxBonusAmount")} - ${getFormattedNumber(max_topup_reward)})`}
          </div>
        </ModalText>
      </div>
    </Modal>
  );
};

export default BonusConfirmModal;
